import clsx from 'clsx';

import { useFakeProgress } from '@atom/hooks/useFakeProgress';
import { LinearProgress, Progress } from '@atom/mui';

import { useChatContext, withChatContext } from './ChatContext';
import ChatHeader from './ChatHeader';
import ChatMessages from './ChatMessages';
import ChatThreads from './ChatThreads';

import classes from './chat.module.css';

const Chat = () => {
  const {
    messagesData: { loading: loadingMessages },
    feedbackData: { loading: loadingFeedback },
    ui: { drawerCollapsed, loading },
  } = useChatContext();

  const { progress: loadingProgress, visible: loadingVisible } =
    useFakeProgress(loading);

  return (
    <div className={classes.chatContainerRoot}>
      <div
        className={clsx(
          classes.chatDrawer,
          !drawerCollapsed && classes.chatDrawerExpanded,
        )}
      >
        <ChatThreads />
      </div>
      <div className={classes.chatMainContainer}>
        <div className={classes.chatContent}>
          <ChatHeader />
          <LinearProgress
            variant="determinate"
            value={loadingProgress}
            style={{ visibility: loadingVisible ? 'visible' : 'hidden' }}
          />
          {loadingMessages || loadingFeedback ? (
            <div className={classes.chatLoading}>
              <Progress />
            </div>
          ) : (
            <ChatMessages />
          )}
        </div>
      </div>
    </div>
  );
};

export default withChatContext(Chat);
